import {RollupProjectDataset} from 'common/types/reports/datasets';

import {BaseClient} from '../utils/base-client';

class DatasetsClient extends BaseClient {
  buildEndpoint({projectId}) {
    return `api/app/projects/${projectId}/datasets/`;
  }

  processResponse(response): RollupProjectDataset[] {
    const {results = null, error = null} = response;

    if (error) {
      throw new Error(`Datasets API error: ${error}`);
    }

    return results;
  }
}

export const datasetsClient = new DatasetsClient();
